import { AnimatePresence } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { theme } from 'styles/theme'
import { useDataContext } from 'context/data-context'
import { Container } from 'components/container'
import { Layout } from 'components/layout'
import RadioImgSrc from 'components/radio/assets/radio-large-article.png'
import { PeopleList } from './people-list'
import {
  ArticleLayout,
  MainContent,
  Person,
  PersonButton,
  RadioImg,
} from './styled'

export const variants = {
  initial: {
    opacity: 0,
  },
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.4,
      ease: theme.easeValues.inOut,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.3,
      ease: theme.easeValues.inOut,
    },
  },
}

export const Article = () => {
  const { year } = useParams()
  const [visibleName, setVisibleName] = useState('')
  const { articles, people } = useDataContext()
  const article = articles[year as string]

  const closePeopleList = () => setVisibleName('')

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [year])

  return (
    <>
      <Layout noFooter headerOnTop>
        <Container>
          <AnimatePresence mode="wait">
            <ArticleLayout
              variants={variants}
              initial="initial"
              animate="enter"
              exit="exit"
              key={year}
            >
              <MainContent>
                {article ? (
                  <>
                    {article.data.length === 0 ? (
                      <>
                        <h2>{year}</h2>
                        <p>Article is empty</p>
                      </>
                    ) : (
                      article.data.map((block, i) => {
                        if (typeof block === 'string') {
                          return <p key={i}>{block}</p>
                        }

                        switch (block.type) {
                          case 'p':
                            return <p key={i}>{block.content}</p>
                          case 'figure':
                            return (
                              <figure key={i}>
                                <img src={block.src} alt="" />
                                {!!block.description && (
                                  <figcaption>{block.description}</figcaption>
                                )}
                              </figure>
                            )
                          case 'iframe':
                            return (
                              // eslint-disable-next-line jsx-a11y/iframe-has-title
                              <iframe
                                key={i}
                                src={block.src}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              ></iframe>
                            )
                          case 'video':
                            return (
                              <video key={i} width="100%" controls>
                                <source src={block.src} />
                              </video>
                            )
                          case 'heading':
                            return (
                              <block.element key={i}>
                                {block.content}
                              </block.element>
                            )
                          case 'person':
                            return people.find(
                              p =>
                                p.name === block.name ||
                                p.shortName === block.name
                            ) ? (
                              <PersonButton
                                key={i}
                                onClick={() => setVisibleName(block.name)}
                              >
                                {block.name}:
                              </PersonButton>
                            ) : (
                              <Person key={i}>{block.name}:</Person>
                            )
                          case 'title':
                            return <h2 key={i}>{block.content}</h2>
                          default:
                            console.warn('unknown block type', block)
                        }
                      })
                    )}
                  </>
                ) : (
                  <p>Article not found</p>
                )}
              </MainContent>
            </ArticleLayout>
          </AnimatePresence>

          <RadioImg isPeopleListOpen={!!visibleName} src={RadioImgSrc} />

          <AnimatePresence>
            {!!visibleName && (
              <PeopleList onClose={closePeopleList} visibleName={visibleName} />
            )}
          </AnimatePresence>
        </Container>
      </Layout>
    </>
  )
}
